export const EXTERNAL_PRODUCT_NAME_MAX_LENGTH = 255;
